import React from "react"
import { WeekType } from "../utilities/getWeekType"

export const WeekTypeContext = React.createContext<WeekType | null>(null)
